export class SalesApproachLayout {
	public sections = [
		{
			title: 'General',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSalesHistoryResearchedIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSalesHistoryResearchedDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSalePriorTransferComparableIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSalePriorComparableDataSource'
						}
					}
				]
			],
		},
		{
			title: 'Prior Sales or Transfers',
			items: [
				[
					{
						cssClass: 'col-md-12',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Property'},
								{ label: 'Date of Prior Sale/Transfer'},
								{ label: 'Price of Prior Sale/Transfer'},
								{ label: 'Data Source(s)'},
								{ label: 'Effective Date of Data Source(s)'},
							],
							comparables: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE',
							rows: [
								{
									cols: [
										{
											options: { label: 'COMP ' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVCompPriorSaleDate',
												displayType: 'date',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVCompPriorSalePrice',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVCompPriorSaleDataSource',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVCompPriorSaleEffectiveDate',
												displayType: 'date',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				]
			],
		},
		{
			title: 'Analysis',
			items: [
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVCompPriorSaleComment'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSaleApproachSummary'
						}
					}
				]
			],
		},
		{
			title: 'Value By Sales Comparison Approach',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSalesComparisonValueIndicatedBySalesComparisonApproachAmount',
							displayType: 'currency'
						}
					}
				]
			],
		}
	];
}